import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page_header"
}
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = {
  key: 1,
  class: "formContainer"
}
const _hoisted_4 = { class: "nav nav-tabs mb-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "ms-1" }
const _hoisted_7 = {
  filter: "edmondMaterialName",
  sort: "edmondMaterialName"
}
const _hoisted_8 = {
  filter: "edmondSuggestedGramsPerSquareMeters",
  filterType: "number",
  sort: "edmondSuggestedGramsPerSquareMeters"
}
const _hoisted_9 = {
  filter: "companyMaterialName",
  sort: "companyMaterialName"
}
const _hoisted_10 = {
  filter: "companySuggestedGramsPerSquareMeters",
  filterType: "number",
  sort: "companySuggestedGramsPerSquareMeters"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { colspan: "99" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.company)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.company.companyName) + " - ", 1),
            _createVNode(_component_localized_text, {
              localizedKey: "Materials",
              text: "Materials"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.company)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "nav-item pointer",
                key: tab.type
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { 'active': _ctx.activeTab == tab.type }]),
                  onClick: ($event: any) => (_ctx.activeTab = tab.type)
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: tab.label,
                    text: tab.label
                  }, null, 8, ["localizedKey", "text"]),
                  _createElementVNode("span", _hoisted_6, "(" + _toDisplayString(_ctx.itemsByType[tab.type].length) + ")", 1)
                ], 10, _hoisted_5)
              ]))
            }), 128))
          ]),
          (_openBlock(), _createBlock(_component_op_table, {
            class: "table table-striped",
            key: _ctx.activeTab,
            items: _ctx.itemsByType[_ctx.activeTab],
            name: 'companyMaterials-' + _ctx.companyId + '-' + _ctx.activeTab
          }, {
            default: _withCtx((opData) => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Edmond Material Name",
                      text: "Edmond Material Name"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Edmond Suggested Grams",
                      text: "Edmond Suggested Grams"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_9, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Company Material Name",
                      text: "Company Material Name"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Company Suggested Grams",
                      text: "Company Suggested Grams"
                    })
                  ]),
                  _hoisted_11
                ])
              ]),
              _createElementVNode("tbody", null, [
                (opData.data.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                      _createElementVNode("td", _hoisted_13, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "No Elements Found",
                          text: "No Elements Found"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.CompanyMaterialConversionVM[]), (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(item.edmondMaterialName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.edmondSuggestedGramsPerSquareMeters), 1),
                    _createElementVNode("td", null, _toDisplayString(item.companyMaterialName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.companySuggestedGramsPerSquareMeters), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: ($event: any) => (_ctx.editMaterialNameAndGrams(item))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Edit for company",
                          text: "Edit for company"
                        })
                      ], 8, _hoisted_14)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["items", "name"]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}